/* eslint-disable spire/export-styles */
import ExternalAuthButton from "@husky-hrc/Components/ExternalAuthButton";
import { propertyTruthy } from "@husky-hrc/Utilities/Utilities";
import mergeToNew from "@insite/client-framework/Common/mergeToNew";
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import { HasProductContext, withProductContext } from "@insite/client-framework/Components/ProductContext";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import { getSettingsCollection } from "@insite/client-framework/Store/Context/ContextSelectors";
import { getCurrentBillToState } from "@insite/client-framework/Store/Data/BillTos/BillTosSelectors";
import loadCurrentBillTo from "@insite/client-framework/Store/Data/BillTos/Handlers/LoadCurrentBillTo";
import { hasEnoughInventory } from "@insite/client-framework/Store/Data/Products/ProductsSelectors";
import { getPageLinkByPageType } from "@insite/client-framework/Store/Links/LinksSelectors";
import translate from "@insite/client-framework/Translate";
import Button, { ButtonPresentationProps } from "@insite/mobius/Button";
import Typography, { TypographyPresentationProps } from "@insite/mobius/Typography";
import { HasHistory, History, withHistory } from "@insite/mobius/utilities/HistoryContext";
import React, { useEffect } from "react";
import { connect, ResolveThunks } from "react-redux";
import { css } from "styled-components";

interface OwnProps {
    labelIfLoggedOut: string;
    labelIfLoggedIn: string;
    labelIfAccountBlocked: string;
    extendedStyles?: ButtonPresentationProps;
    returnUrl?: string;
}

type Props = OwnProps &
    HasHistory &
    ReturnType<typeof mapStateToProps> &
    ResolveThunks<typeof mapDispatchToProps> &
    HasProductContext;

const mapStateToProps = (state: ApplicationState, props: HasProductContext) => {
    return {
        productSettings: getSettingsCollection(state).productSettings,
        hasEnoughInventory: hasEnoughInventory(state, props.productContext),
        addingProductToCart: state.context.addingProductToCart,
        userName: state.context.session.userName,
        currentBillToState: getCurrentBillToState(state),
        productConfigPageUrl: getPageLinkByPageType(state, "ProductConfigPage")?.url,
    };
};

const mapDispatchToProps = {
    loadCurrentBillTo,
};

export const productTactonConfigButtonStyles: ButtonPresentationProps = {};

const wrapperStyles = {
    css: css`
        width: 100%;
        display: flex;
        flex-direction: column;
        padding: 2rem 0 0;
    `,
};

const TactonConfigButton: React.FC<Props> = ({
    history,
    loadCurrentBillTo,
    currentBillToState,
    productContext: {
        product,
        productInfo: { qtyOrdered, unitOfMeasure, inventory },
    },
    productSettings,
    hasEnoughInventory,
    extendedStyles,
    userName,
    labelIfLoggedIn,
    labelIfLoggedOut,
    labelIfAccountBlocked,
    returnUrl,
    productConfigPageUrl,
    ...otherProps
}) => {
    const [styles] = React.useState(() => mergeToNew(productTactonConfigButtonStyles, extendedStyles));

    useEffect(() => {
        if (userName && !currentBillToState.value && !currentBillToState.isLoading) {
            loadCurrentBillTo();
        }
    }, [userName]);

    const configurationButtonHandler = (history: History) => {
        if (productConfigPageUrl) {
            history.push(`${productConfigPageUrl}?productId=${product.id}&returnUrl=${returnUrl}`);
        }
    };

    const tactonBlocked = (currentBillToState: any) => {
        return propertyTruthy(currentBillToState?.value?.properties?.tactonBlocked);
    };

    if (!userName) {
        return (
            <>
                <ExternalAuthButton authButtonText={labelIfLoggedOut} extendedStyles={styles} variant="primary" />
            </>
        );
    }

    return (
        <>
            <StyledWrapper {...wrapperStyles}>

                <Button
                    disabled={tactonBlocked(currentBillToState) || !product.canAddToCart}
                    {...styles}
                    onClick={() => configurationButtonHandler(history)}
                    {...otherProps}
                >
                    {tactonBlocked(currentBillToState) ? labelIfAccountBlocked : labelIfLoggedIn}
                </Button>
            </StyledWrapper>
        </>
    );
};

export default withProductContext(connect(mapStateToProps, mapDispatchToProps)(withHistory(TactonConfigButton)));
